import { create } from 'zustand';
import { fetchDonors } from '../api';
import { useErrorStore } from './useErrorStore';

export interface Donor {
  id: number;
  donorType?: string;
  name: string;
  phone: string;
  address?: string;
  city?: string;
  state?: string;
  country?: string;
  pincode?: string;
  pan?: string;
  email?: string;
  whatsappGroup?: boolean;
  note?: string;
  createdAt?: string;
  updatedAt?: string;
}

interface DonorsState {
  donors: Donor[];
  loading: boolean;
  refresh: (hotlistFilter?: string) => Promise<void>;
}

export const useDonorsStore = create<DonorsState>((set) => ({
  donors: [],
  loading: false,
  refresh: async (hotlistFilter = 'all') => {
    set({ loading: true });
    try {
      const data = await fetchDonors(hotlistFilter);
      set({ donors: Array.isArray(data) ? data : [], loading: false });
    } catch (error) {
      useErrorStore.getState().setError('Failed to fetch donors.');
      set({ loading: false });
    }
  },
}));
